<template>
  <v-footer app class="footer">
    <v-container fluid class="footer-content">
      <!-- Logo 區域 -->
      <div class="logo">
        <img 
          src="/logowhite.png" 
          alt="Logo" 
          class="logo-image"
        />
      </div>
      <!-- 連結區域 -->
      <div class="footer-links">
        <router-link 
          v-for="(link, index) in links" 
          :key="index" 
          :to="getLinkHref(link)" 
          class="footer-link"
          @mouseover="hoverLink = link"
          @mouseleave="hoverLink = null"
          :class="{ hover: hoverLink === link }"
        >
          {{ link }}
          <span v-if="index < links.length - 1" class="separator">|</span>
        </router-link>
      </div>
    </v-container>
    <!-- 版權聲明 -->
    <v-container fluid class="footer-text">
      <p>© 2024 Institute for Information Industry. All Rights Reserved.</p>
    </v-container>
  </v-footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      links: ['網站導覽', '隱私權政策', '意見信箱'],
      hoverLink: null,  // 用於存儲懸浮的連結名稱
    };
  },
  methods: {
    getLinkHref(link) {
      // 根據連結名稱設置對應的路徑
      switch (link) {
        case '網站導覽':
          return '/websiteguide';
        case '隱私權政策':
          return '/privacy';
        case '意見信箱':
          return '/feedback';
        default:
          return '#';
      }
    }
  }
};
</script>

<style scoped>
.footer {
  width: 100%;
  background-color: #000000; /* 黑色背景 */
  padding: 2% 0; /* 使用百分比設置上下內部間距 */
  display: flex;
  flex-direction: column; /* 縱向排列內容 */
  align-items: center; /* 置中對齊 */
  color: #ffffff; /* 白色文字 */
}

.footer-content {
  display: flex;
  align-items: center; /* 垂直置中 */
  justify-content: space-between; /* 內容左右分開 */
  width: 90%; /* 設定寬度為90% */
}

.logo {
  font-size: 1.5em; /* 字體大小 */
}

.logo-image {
  width: 120px; /* 調整圖片寬度 */
  height: auto; /* 保持比例 */
}

.footer-links {
  display: flex; /* 橫向排列連結 */
  gap: 1em; /* 連結之間的間距 */
}

.footer-link {
  color: #ffffff; /* 白色文字 */
  text-decoration: none; /* 去除下劃線 */
  transition: color 0.3s;
  font-size: 1em; /* 字體大小 */
}

.footer-link:hover,
.footer-link.hover {
  color: #1abc9c; /* 懸停和懸浮時顏色 */
}

.separator {
  color: #ffffff; /* 分隔符顏色 */
  font-size: 1em; /* 字體大小 */
}

.footer-text {
  font-size: 0.8em; /* 字體大小 */
  color: #ffffff; /* 白色文字 */
  margin-top: 1%; /* 上邊距 */
  text-align: center; /* 置中對齊 */
}
</style>
